module.exports = __webpack_public_path__ + "img/nadvorie2.f9bf993c.jpg";